import React from "react";
import { useNavigate } from "react-router-dom";
import "./ConsultSection.css";

const problems = [
  {
    icon: "❤️",
    iconBg: "#fff0f3",
    iconColor: "#e84393",
    title: "Love & Relationship",
    desc: "Find clarity in your heart and resolve relationship conflicts.",
  },
  {
    icon: "💼",
    iconBg: "#f0f4ff",
    iconColor: "#4361ee",
    title: "Career & Job",
    desc: "Get guidance on promotions, job changes, and career growth.",
  },
  {
    icon: "👫",
    iconBg: "#fff4f0",
    iconColor: "#e8633a",
    title: "Marriage",
    desc: "Resolve delays in marriage or find your ideal life partner.",
  },
  {
    icon: "💰",
    iconBg: "#f0fff4",
    iconColor: "#22a06b",
    title: "Money & Finance",
    desc: "Overcome financial hurdles and attract wealth into your life.",
  },
  {
    icon: "🩺",
    iconBg: "#f0fffe",
    iconColor: "#0ea5e9",
    title: "Health",
    desc: "Understand planetary influences on your physical well-being.",
  },
  {
    icon: "🎓",
    iconBg: "#f5f0ff",
    iconColor: "#7c3aed",
    title: "Education",
    desc: "Achieve success in studies and competitive examinations.",
  },
  {
    icon: "⚖️",
    iconBg: "#fffbf0",
    iconColor: "#d97706",
    title: "Legal Matters",
    desc: "Navigate through court cases and legal disputes effectively.",
  },
  {
    icon: "🏢",
    iconBg: "#f5f0ff",
    iconColor: "#6d28d9",
    title: "Business",
    desc: "Strategies for business expansion and overcoming losses.",
  },
];

const ConsultSection = () => {
  const navigate = useNavigate();

  return (
    <section className="cs-section">
      {/* Header */}
      <div className="cs-header">
        <h2 className="cs-title">
          Consult for <span className="cs-pink">Any Problem</span>
        </h2>
        <p className="cs-sub">
          Our expert astrologers provide deep insights and effective remedies for all life challenges.
        </p>
      </div>

      {/* Grid */}
      <div className="cs-grid">
        {problems.map((p, i) => (
          <div className="cs-card" key={i}>
            {/* Icon */}
            <div
              className="cs-icon-wrap"
              style={{ background: p.iconBg }}
            >
              <span className="cs-icon">{p.icon}</span>
            </div>

            <h3 className="cs-card-title">{p.title}</h3>
            <p className="cs-card-desc">{p.desc}</p>

            <button
              className="cs-btn cs-btn-chat"
              onClick={() => navigate("/chat-with-astrologer")}
            >
              CHAT NOW
            </button>
            <button
              className="cs-btn cs-btn-call"
              onClick={() => navigate("/call-with-astrologer")}
            >
              CALL NOW
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ConsultSection;